import httpInstance from "./httpClient";

/**
 * @param msAccessToken - Microsoft OAuth access token from login
 * @returns Promise with verification result and Minecraft profile
 */
export const verifyMinecraftOwnership = async (msAccessToken: string) => {
  return httpInstance.post("/minecraft/verify-ownership", {
    ms_access_token: msAccessToken,
  }).then((result) => {
    return result;
  }).catch((error) => {
    console.error("[MinecraftService] Ownership verification error:", error);
    throw error;
  });
};

/**
 * Upload a generated skin to the authenticated user's Minecraft account.
 *
 * SECURITY: This function does NOT send Microsoft tokens from the client.
 * The backend securely retrieves the MS token from the database for the authenticated user.
 *
 * @param generationId - ID of the generation containing the skin
 * @param imageIndex - Index of the specific image to upload (0-3 typically)
 * @param variant - Skin model variant: "classic" (Steve) or "slim" (Alex)
 * @returns Promise with upload result
 */
export const uploadSkinToMinecraft = async (
  generationId: string,
  imageIndex: number,
  variant: "classic" | "slim" = "classic"
) => {
  // Authentication is handled via Firebase token in httpInstance interceptor
  // MS token is securely retrieved from database on the backend (NOT sent from client)
  return httpInstance.post(
    `/minecraft/upload-skin?generation_id=${generationId}&image_index=${imageIndex}&variant=${variant}`
  );
};

/**
 * @returns Promise with current skin information
 */
export const getCurrentMinecraftSkin = async () => {
  return httpInstance.get("/minecraft/current-skin");
};

/**
 * Upload any skin (URL or Data URL) to the authenticated user's Minecraft account.
 * Use this for edited skins or skins not directly linked to a Generation ID.
 * 
 * @param skinUrl - The public URL or Data URL (base64) of the skin
 * @param variant - Skin model variant
 */
export const uploadCustomSkinToMinecraft = async (
  skinUrl: string,
  variant: "classic" | "slim" = "classic"
) => {
  return httpInstance.post("/minecraft/skin/upload", {
    skin_url: skinUrl,
    variant: variant
  });
};
